<div class="flyout-distributed-coupons-component">
  <div class="flyout-data-group">
    <mat-expansion-panel [expanded]="true" class="mat-elevation-z0">
      <mat-expansion-panel-header [collapsedHeight]="'48px'" [expandedHeight]="'48px'">
        <mat-icon class="header-icon">local_offer</mat-icon>
        <span>{{ "flyout.distributed-coupons.title" | translate }}</span>
      </mat-expansion-panel-header>

      <div class="expansion-panel-row header">
        <div class="label name">
          <span>{{ "flyout.distributed-coupons.code" | translate }}</span>
        </div>
        <div class="label value-label">
          <span>{{ "flyout.distributed-coupons.copied" | translate }}</span>
        </div>
      </div>

      @for (coupon of coupons; track coupon) {
        <div class="expansion-panel-row values">
          <div class="column content">
            <div class="content-row text">
              <div class="icon-column">
                <app-tb-icon [icon]="'tb:discount-code'" [isImage]="false"></app-tb-icon>
              </div>
              <div class="text-column">
                <span class="campaign-name">{{ coupon.code }}</span>
              </div>
              <span class="copied-cell">
                @if (coupon.isCopied) {
                  <mat-icon class="coupon-copied-icon" fontIcon="check"></mat-icon>
                }
                @if (!coupon.isCopied) {
                  <mat-icon class="coupon-not-copied-icon" fontIcon="close"></mat-icon>
                }
              </span>
            </div>
          </div>
        </div>
      }
    </mat-expansion-panel>
  </div>
</div>
